export const INQUIRY_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'under_review', label: 'Under Review' },
  { value: 'costing_in_progress', label: 'Costing in Progress' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'follow_up', label: 'Follow-up' },
  { value: 'won', label: 'Won' },
  { value: 'lost', label: 'Lost' },
  { value: 'closed', label: 'Closed' },
];

export const CLOSURE_REASONS = [
  ['not_technically_feasible', 'Not technically feasible'],
  ['material_not_available', 'Material / grade not available'],
  ['quantity_too_low', 'Quantity too low'],
  ['lead_time_not_achievable', 'Lead time not achievable'],
  ['customer_cancelled', 'Customer cancelled'],
  ['commercially_not_viable', 'Commercially not viable'],
  ['no_suitable_vendor', 'No suitable vendor / source'],
  ['insufficient_information', 'Insufficient information'],
  ['other', 'Other'],
].map(([value, label]) => ({ value, label }));

export const STATUS_STYLES = {
  new: 'bg-blue-100 text-blue-800 border-blue-200',
  under_review: 'bg-amber-100 text-amber-800 border-amber-200',
  costing_in_progress: 'bg-violet-100 text-violet-800 border-violet-200',
  quoted: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  follow_up: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  won: 'bg-green-100 text-green-800 border-green-200',
  lost: 'bg-red-100 text-red-800 border-red-200',
  closed: 'bg-slate-100 text-slate-700 border-slate-200',
  draft: 'bg-slate-100 text-slate-700 border-slate-200',
  open: 'bg-blue-100 text-blue-800 border-blue-200',
};

export const statusLabel = (status) => (
  INQUIRY_STATUSES.find((item) => item.value === status)?.label
  || String(status || 'new').replaceAll('_', ' ')
);